// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1USek","errorLogs":"styles_errorLogs__gElqR"};